// const host = process.env.API_URL || "http://localhost:3000/client/graphql";
const host =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3008/client/graphql"
    : "https://preferr.herokuapp.com/client/graphql";

export { host };
